import { render, staticRenderFns } from "./typeTips2.vue?vue&type=template&id=ac043c2a&scoped=true"
import script from "./typeTips2.vue?vue&type=script&lang=js"
export * from "./typeTips2.vue?vue&type=script&lang=js"
import style0 from "./typeTips2.vue?vue&type=style&index=0&id=ac043c2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac043c2a",
  null
  
)

export default component.exports